import Vue from 'vue'
import Vuex from 'vuex'
import InitConfig from './modules/initConfig'
import Llamadas from './modules/llamadas'
import Numeros from './modules/numeros'
import Appointment from './modules/AutoRecepcion/appointment/module'
import Patient from './modules/AutoRecepcion/patient/module'
import GeneralAR from './modules/AutoRecepcion/general'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    ajaxCounter: 0,
    apiUrl: null
  },
  mutations: {
    incrementAjaxCounter: (state) => {
      state.ajaxCounter++
    },
    decrementAjaxCounter: (state) => {
      state.ajaxCounter--
    },
    setApiUrl: (state, res) => {
      state.apiUrl = res
    }
  },
  actions: {
  },
  getters: {
    getAjaxCounter: state => {
      return state.ajaxCounter
    },
    getApiUrl: state => {
      return state.apiUrl
    }
  },
  modules: {
    InitConfig,
    Llamadas,
    Numeros,
    Appointment,
    Patient,
    GeneralAR
  }
})
